import { all, call, put, take, takeEvery } from 'redux-saga/effects'
import { t } from 'ttag'
import { getWhoAmI, getWhoAmIFail, getWhoAmISuccess } from '../../../common/auth/authActions'
import { addNotification, clearNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import api from '../../../services/api.services'
import { doGoogleSignIn } from './GoogleSignInActions'
import { push } from 'connected-react-router'
import { isNative } from '../../../common/helpers/isNative'
import { dataSync } from '../../../services/DataSync'
import { Preferences } from '@capacitor/preferences'

function* sagaGoogleSignIn({ payload }: any) {
  document.body.classList.add('logging-in')
  if (payload.redirectTo) {
    yield put(push(payload.redirectTo))
  }
  try {
    const { authorizationCode, redirectUri, nonce, lang, signUpCode } = payload
    yield put({ type: String(clearNotification) })
    yield call(api.auth.googleSignIn, { authorizationCode, redirectUri, nonce, lang, signUpCode })
    //const { sessionId: sessionToken } = yield call(api.auth.googleSignIn, { authorizationCode, redirectUri, nonce, lang, signUpCode })
    //yield Preferences.set({ key: 'sessionToken', value: sessionToken })

    // Ensure that you're logged in now.
    yield put({ type: String(getWhoAmI) })

    // Wait for getWhoAmI to finish.
    yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])

    // Make sure AH or GF is synced on login.
    if (isNative()) {
      setTimeout(() => {
        dataSync(true).then()
      }, 1000)
    }

    /*const successfulSignupNotification: INotification = {
      type: 'success',
      content: t`Great, you've successfully registered! For next, please choose your integration.`,
    }
    yield put({ type: String(addNotification), payload: successfulSignupNotification })*/

    yield put(push('/register-user'))
    yield Preferences.remove({ key: 'googleSignInNonce' })
    yield Preferences.remove({ key: 'googleSignUpCode' })
  } catch (e: any) {
    let signupErrorNotification: INotification
    if (e.message && e.message === 'noRelatedCompany') {
      signupErrorNotification = {
        type: 'warning',
        content: t`Sorry, we did not find a related YuMuuv company to your Google account. Please sign up using sign up code and email or contact support@yumuuv.com`,
      }
    } else if (e.message && e.message === 'invalidCompanyCode') {
      signupErrorNotification = {
        type: 'warning',
        content: t`Sorry, the sign up code provided is not valid`,
      }
    } else if (e.message && e.message === 'disallowedDomain') {
      signupErrorNotification = {
        type: 'warning',
        content: t`Sorry, the sign up code provided does not allow signing up with the specified email address. Please sign up using another email address or contact your employer.`,
      }
    } else if (e.message && e.message === 'disallowedRegion') {
      signupErrorNotification = {
        type: 'warning',
        content: t`Sorry, the given sign up code does not allow signing up from your region.`,
      }
    } else if (e.message && e.message === 'userLimitExceeded') {
      signupErrorNotification = {
        type: 'warning',
        content: t`Sorry, this community has exceeded it's user limit. Please contact your challenge organizer for more info.`,
      }
    } else {
      /*
       * Additional error options:
       *  * googleUserNotFound
       *  * emailUnverified
       *  * invalidIdToken
       * */
      signupErrorNotification = {
        type: 'warning',
        content: t`There was a problem with your Google account. Please try again or try signing up using sign up code and email or contact our support support@yumuuv.com`,
        // + (e.message ? ` (${e.message})` : ''),
      }
    }
    yield put({ type: String(addNotification), payload: signupErrorNotification })
  }
  document.body.classList.remove('logging-in')
}

export function* googleSignInSagas() {
  yield all([takeEvery(String(doGoogleSignIn), sagaGoogleSignIn)])
}
